import { render } from "./CreateNewRuleCards.vue?vue&type=template&id=4ae19dfa"
import script from "./CreateNewRuleCards.vue?vue&type=script&lang=js"
export * from "./CreateNewRuleCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/CreateNewRuleCards.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ae19dfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ae19dfa', __exports__)) {
    api.reload('4ae19dfa', __exports__)
  }
  
  module.hot.accept("./CreateNewRuleCards.vue?vue&type=template&id=4ae19dfa", () => {
    api.rerender('4ae19dfa', render)
  })

}


export default __exports__